import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=063b1efb"
import script from "./Legends.vue?vue&type=script&lang=js"
export * from "./Legends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports